import { combineEpics } from "redux-observable";

export const esoEpic = combineEpics();
